<template>
  <div id="app">
    <!-- Header -->
    <header class="site-header">
      <NavBar />
    </header>

    <!-- Main content -->
    <main class="site-content">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-content">
        <p>&copy; 2026 Social Conscience PBC. All rights reserved.</p>
        <div class="footer-links">
          <a href="/privacy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';

export default {
  name: 'App',
  components: { NavBar }
};
</script>

<style>
/* CSS Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  color: hsl(0, 0%, 20%);
  line-height: 1.6;
  background: #fff;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid #eee;
}

/* Main content area */
.site-content {
  flex: 1;
}

/* Footer */
.site-footer {
  background: #fff;
  border-top: 1px solid #eee;
  padding: 40px 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-content p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: hsl(155, 100%, 22%);
}

/* Global Typography */
h1 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 20px;
}

h2 {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

h3 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 12px;
}

p {
  font-size: 18px;
  line-height: 1.7;
  margin-bottom: 16px;
}

/* Global Button Styles */
.btn {
  display: inline-block;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-primary {
  background: hsl(155, 100%, 22%);
  color: #fff;
}

.btn-primary:hover {
  background: hsl(155, 100%, 18%);
  transform: translateY(-1px);
}

.btn-secondary {
  background: hsl(0, 0%, 20%);
  color: #fff;
}

.btn-secondary:hover {
  background: hsl(0, 0%, 10%);
  transform: translateY(-1px);
}

.btn-outline {
  background: transparent;
  color: hsl(0, 0%, 20%);
  border: 2px solid hsl(0, 0%, 20%);
}

.btn-outline:hover {
  background: hsl(0, 0%, 20%);
  color: #fff;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Section spacing */
.section {
  padding: 80px 0;
}

.section-alt {
  background: hsl(142, 38%, 97%);
}

/* Responsive */
@media (max-width: 768px) {
  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 26px;
  }

  p {
    font-size: 16px;
  }

  .section {
    padding: 60px 0;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }
}
</style>
